<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{this.title | translate}}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <vue-plotly :white-mode="whiteMode" v-if="data1" disable-responsive :data="data1" :layout="layout1" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import VuePlotly from "@/components/VuePlotly";
    export default {
        props: {
            title: {type: String, default: 'Chiller Sequencing Profile - % of FLA'},
            yTitle: {type: String, default: '% of FLA'},
            xTitle: {type: String, default: 'Building Cooling Load'},
            dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
        },
        name: 'ChillerSequencingFlaWidget',
        components: {VuePlotly},
        watch: {
            dateRange(){
                this.getData()
            }
        },
        data () {
            return {
                menu:false,
                loading:true,
                timeout: null,
                data1:null,
                layout1:{
                    yaxis: {
                        title: this.$options.filters.translate(this.yTitle)
                    },
                    xaxis: {
                        title: this.$options.filters.translate(this.xTitle)
                    },
                    legend: {
                        orientation: 'h',
                        traceorder:'normal',
                        y:-0.2
                    },
                    showlegend:true,
                    hoverlabel: {
                        namelength: -1,
                    },
                    margin:{
                        l: 50,
                        r: 50,
                        t: 50,
                        pad: 1
                    },
                },
            }
        },
        mounted() {
            this.refresh();
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.dateRange.start,me.dateRange.end]
                let chillers=[]
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        let allSensors=this.$store.state.pointsListStore.pointsList.sensors[i]
                        if(allSensors.indexOf("Cooling_Load")>-1){
                            chillers.push(equip.equipment_name)
                        }
                    }
                }
                callAPI('stagingprofile/',{
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                    equipment_names:chillers
                }).then(function(result){
                    let data1=[]
                    for (let index in result.data.result){
                        let index1 = index.replace(/[{}]/g, "")
                        data1.push({
                          name: index1,
                          x:result.data.result[index].Cooling_Load,
                          y:result.data.result[index].FLA.map(x=>x*100),
                          mode:'markers'
                        })
                    }
                    me.data1=data1
                    me.loading=false
                })
            }
        },
    }
</script>
